module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("什么是虚拟组件(virtual component)")]), _vm._v(" "), _c('h2', [_vm._v("概念")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("虚拟组件")]), _vm._v(" 是 "), _c('code', [_vm._v("VUX")]), _vm._v(" 组件特有的概念。它指的是一个组件不需要 "), _c('code', [_vm._v("import")]), _vm._v(" 就能使用，组件的代码会在编译时被 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 替换成真实的 "), _c('code', [_vm._v("html")]), _vm._v(" 代码，比如 "), _c('code', [_vm._v("x-icon")]), _vm._v(" 组件。")]), _vm._v(" "), _c('h2', [_vm._v("为什么这样实现")]), _vm._v(" "), _c('p', [_vm._v("它可以解决按需引入的问题，比如不需要把所有 "), _c('code', [_vm._v("svg")]), _vm._v(" 引入组件而是在编译时根据属性读取相应的 "), _c('code', [_vm._v("svg")]), _vm._v(" 图标直接内联。")]), _vm._v(" "), _c('p', [_vm._v("它可以解决特殊属性的赋值问题，或者自定义一些特殊写法。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b07bef2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-8b07bef2"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/what-is-vux-virtual-component-21.vue
// module id = 2385
// module chunks = 189